export default {"src":"/_next/static/media/map.9a6064a6.svg","height":638,"width":888,"blurWidth":0,"blurHeight":0};